// extracted by mini-css-extract-plugin
export default {"splash":"AppLoading_splash__Bqgga","splash_container":"AppLoading_splash_container__OrlNV","fade-in":"AppLoading_fade-in__piAWq","progress":"AppLoading_progress__Nv6Gd"};